<!-- 人才推荐 -->
<template>
  <div>
    <!-- banner -->
    <BannerJoinUs />

    <div class="container-1600 pt-[35px]">
      <div class="flex items-center">
        <span>当前位置：</span>
        <el-breadcrumb separator-class="el-icon-arrow-right" class="!text-[16px]">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>人才服务</el-breadcrumb-item>
          <el-breadcrumb-item>人才推荐</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form :model="form" :rules="rules" ref="form" label-width="180px">
        <div>
          <!-- 被推荐人信息 -->
          <h2 class="recommend-h2 relative mb-[60px] text-center text-[20px] font-bold">被推荐人信息</h2>
          <div class="grid grid-cols-3">
            <el-form-item label="姓名" prop="name">
              <el-input size="medium" v-model="form.name"></el-input>
            </el-form-item>

            <el-form-item label="手机号" prop="phone">
              <el-input size="medium" v-model="form.phone">
                <template slot="prepend">+86</template>
              </el-input>
            </el-form-item>

            <el-form-item label="邮箱" prop="email">
              <el-input size="medium" v-model="form.email"></el-input>
            </el-form-item>

            <el-form-item label="性别" prop="sex">
              <el-select size="medium" class="w-full" v-model="form.sex">
                <el-option
                  v-for="item in sexOptions"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="出生日期" prop="birthday">
              <el-date-picker type="date" placeholder="请选择出生日期" v-model="form.birthday" style="width: 100%">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="学历" prop="xueli">
              <el-select size="medium" class="w-full" v-model="form.xueli">
                <el-option
                  v-for="item in options.xueli.sub"
                  :key="item.id"
                  :value="item.id"
                  :label="item.title"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="学位" prop="xuewei">
              <el-select size="medium" class="w-full" v-model="form.xuewei">
                <el-option
                  v-for="item in options.xuewei.sub"
                  :key="item.id"
                  :value="item.id"
                  :label="item.title"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="所学专业" prop="suoxuezhuanye">
              <el-input size="medium" v-model="form.suoxuezhuanye"></el-input>
            </el-form-item>

            <el-form-item label="研究方向" prop="direction">
              <el-input size="medium" v-model="form.direction"></el-input>
            </el-form-item>

            <el-form-item label="毕业时间" prop="date">
              <el-date-picker type="date" placeholder="请选择毕业时间" v-model="form.date" style="width: 100%">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="毕业学校" prop="school">
              <el-input size="medium" v-model="form.school"></el-input>
            </el-form-item>

            <el-form-item label="当前工作单位" prop="workunit">
              <el-input size="medium" v-model="form.workunit"></el-input>
            </el-form-item>

            <el-form-item label="当前岗位" prop="position">
              <el-input size="medium" v-model="form.position"></el-input>
            </el-form-item>

            <el-form-item label="开始工作时间" prop="startDate">
              <el-date-picker type="date" placeholder="请选择开始工作时间" v-model="form.startDate" style="width: 100%">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="工作地点" prop="workPosition">
              <el-input size="medium" v-model="form.workPosition"></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="被推荐人简介" prop="summary">
              <el-input
                type="textarea"
                :rows="5"
                v-model="form.summary"
                placeholder="请输入被推荐人简介（200字以内）"
                maxlength="200"
                show-word-limit
                resize="none"
              ></el-input>
            </el-form-item>

            <el-form-item label="学历类别">
              <el-radio-group v-model="form.xueliCate">
                <el-radio label="1">博士后以下岗位</el-radio>
                <el-radio label="2">博士后岗位</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="岗位信息">
              <el-input size="medium" v-model="form.unitInfo"></el-input>
            </el-form-item>
          </div>
        </div>
        <div>
          <!-- 推荐人信息 -->
          <h2 class="recommend-h2 relative mb-[60px] text-center text-[20px] font-bold">推荐人信息</h2>
          <div class="grid grid-cols-3">
            <el-form-item label="姓名" prop="name2">
              <el-input size="medium" v-model="form.name2"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email2">
              <el-input size="medium" v-model="form.email2"></el-input>
            </el-form-item>
            <el-form-item label="所在单位" prop="unit2">
              <el-input size="medium" v-model="form.unit2"></el-input>
            </el-form-item>
            <el-form-item label="职称/职务" prop="position2">
              <el-input size="medium" v-model="form.position2"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone2">
              <el-input size="medium" v-model="form.phone2"></el-input>
            </el-form-item>
          </div>
        </div>
        <div>
          <!-- 提交 -->
          <div class="mt-[19px] text-center">
            <el-checkbox v-model="checked" class="">
              我接受
              <span class="text-[#00f]" @click.prevent="dialogVisibleAgreement = true">用户协议</span>
              和
              <span class="text-[#00f]" @click.prevent="dialogVisiblePolicy = true">隐私政策</span>
            </el-checkbox>
          </div>
          <div class="mt-[24px] text-center">
            <el-button type="primary" size="medium" @click="submitForm">提交</el-button>
          </div>
        </div>
      </el-form>
    </div>

    <!-- 弹窗 -->
    <el-dialog
      title="用户协议"
      :visible.sync="dialogVisibleAgreement"
      width="30%"
      :before-close="handleClose"
      :show-close="false"
    >
      <span>我们将严格保密</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisibleAgreement = false">确 定</el-button>
      </span>
    </el-dialog>
    
    <el-dialog
      title="隐私政策"
      :visible.sync="dialogVisiblePolicy"
      width="30%"
      :before-close="handleClose"
      :show-close="false"
    >
      <span>我们将严格保密</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisiblePolicy = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BannerJoinUs from '@/components/BannerJoinUs.vue';
import { getOptions } from '@/api/resume';

export default {
  name: 'TalentRecommend',
  components: {
    BannerJoinUs,
  },
  data() {
    return {
      checked: false,
      dialogVisibleAgreement: false,
      dialogVisiblePolicy: false,
      // 性别选项
      sexOptions: [
        {
          value: '1',
          label: '男',
        },
        {
          value: '2',
          label: '女',
        },
      ],
      // 下拉框选项
      options: {
        hunyinzhuangkuang: {
          id: '1',
          title: '婚姻状况',
          pid: '0',
          sub: [
            {
              id: '2',
              title: '未婚',
              pid: '1',
            },
          ],
        },
        zhengzhimianmao: {
          id: '5',
          title: '政治面貌',
          pid: '0',
          sub: [
            {
              id: '6',
              title: '中国共产党党员',
              pid: '5',
            },
          ],
        },
        zhengjianleixing: {
          id: '11',
          title: '证件类型',
          pid: '0',
          sub: [
            {
              id: '12',
              title: '身份证',
              pid: '11',
            },
          ],
        },
        zuigaoxueli: {
          id: '20',
          title: '最高学历',
          pid: '0',
          sub: [
            {
              id: '21',
              title: '初中及以下',
              pid: '20',
            },
          ],
        },
        xuewei: {
          id: '33',
          title: '学位',
          pid: '0',
          sub: [
            {
              id: '34',
              title: '学士',
              pid: '33',
            },
          ],
        },
        xueli: {
          id: '40',
          title: '学历',
          pid: '0',
          sub: [
            {
              id: '41',
              title: '初中及以下',
              pid: '40',
            },
          ],
        },
        'guoji/diqu': {
          id: '53',
          title: '国籍/地区',
          pid: '0',
          sub: [
            {
              id: '54',
              title: '中国',
              pid: '53',
            },
          ],
        },
        minzu: {
          id: '253',
          title: '民族',
          pid: '0',
          sub: [
            {
              id: '254',
              title: '汉族',
              pid: '253',
            },
          ],
        },
        yuzhong: {
          id: '310',
          title: '语种',
          pid: '0',
          sub: [
            {
              id: '311',
              title: '英语',
              pid: '310',
            },
          ],
        },
        nengli: {
          id: '323',
          title: '能力',
          pid: '0',
          sub: [
            {
              id: '324',
              title: '普通',
              pid: '323',
            },
          ],
        },
      },
      form: {
        name: '',
        phone: '',
        email: '',
        sex: '男',
        birthday: '',
        xueli: '',
        xuewei: '',
        suoxuezhuanye: '',
        direction: '',
        date: '',
        school: '',
        workunit: '',
        position: '',
        startDate: '',
        workPosition: '',
        summary: '',
        xueliCate: '1',
        unitInfo: '',
        name2: '',
        email2: '',
        unit2: '',
        position2: '',
        phone2: '',
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'change' },
          {
            pattern: /^1\d{10}$/,
            message: '请输入正确的手机号码',
            trigger: 'change',
          },
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'change' },
          {
            pattern:
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: '请输入正确的邮箱',
            trigger: 'change',
          },
        ],
        sex: [{ required: true, message: '请输入姓名', trigger: 'change' }],
        birthday: [{ required: true, message: '请选择出生日期', trigger: 'change' }],
        xueli: [{ required: true, message: '请选择学历', trigger: 'blur' }],
        xuewei: [{ required: true, message: '请选择学位', trigger: 'blur' }],
        suoxuezhuanye: [{ required: true, message: '请输入所学专业', trigger: 'blur' }],
        direction: [{ required: true, message: '请输入研究方向', trigger: 'blur' }],
        date: [{ required: true, message: '请选择毕业时间', trigger: 'blur' }],
        school: [{ required: true, message: '请输入毕业学校', trigger: 'blur' }],
        workunit: [{ required: true, message: '请输入当前工作单位', trigger: 'blur' }],
        position: [{ required: true, message: '请输入当前岗位', trigger: 'blur' }],
        startDate: [{ required: true, message: '请选择开始工作时间', trigger: 'blur' }],
        workPosition: [{ required: true, message: '请输入工作地点', trigger: 'blur' }],
        summary: [{ required: true, message: '请输入被推荐人简介', trigger: 'blur' }],
        name2: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        email2: [
          { required: true, message: '请输入邮箱', trigger: 'change' },
          {
            pattern:
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: '请输入正确的邮箱',
            trigger: 'change',
          },
        ],
        unit2: [{ required: true, message: '请输入所在单位', trigger: 'blur' }],
        position2: [{ required: true, message: '请输入职称/职务', trigger: 'blur' }],
        phone2: [
          { required: true, message: '请输入手机号', trigger: 'change' },
          {
            pattern: /^1\d{10}$/,
            message: '请输入正确的手机号码',
            trigger: 'change',
          },
        ],
      },
    };
  },
  methods: {
    submitForm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          console.log('submit');
          if (this.checked === false) {
            this.$message.error('请先阅读并同意《用户协议》和《隐私政策》');
            return false;
          } else {
            return true;
          }
        } else {
          this.$message.error('请检查表单填写');
          console.log('error submit');
          return false;
        }
      });
    },
    handleClose() {},
  },
  mounted() {
    getOptions().then((res) => {
      this.options = res.data;
    });
  },
};
</script>

<style lang="scss" scoped>
.recommend-h2:after {
  content: '';
  display: inline-block;
  width: 76px;
  height: 3px;
  background-color: #ed9329;
  position: absolute;
  bottom: -16px;
  left: 50%;
  transform: translateX(-50%);
}
::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: inherit !important;
}
</style>
